import {
  useCallback, useState 
} from "react";

const useMobileFilter = (props) => {
  const {
    onApplyFilter,
    selectedColorIds: propsSelectedColorIds,
    selectedCategoryId: propsSelectedCategoryId
  } = props;

  const [selectedColorIds, setSelectedColorIds] = useState(propsSelectedColorIds);

  const [selectedCategoryId, setSelectedCategoryId] = useState(propsSelectedCategoryId);

  const [mobileFilterModalVisible, setMobileFilterModalVisible] =
        useState(false);

  const onFilterItemClick = useCallback(() => {
    setMobileFilterModalVisible(true);
  }, []);

  const onApply = useCallback(
    (colorIds, categoryId) => {
      setSelectedColorIds(colorIds);
      setSelectedCategoryId(categoryId);
      onApplyFilter(colorIds, categoryId);
    },
    [onApplyFilter, selectedColorIds, selectedCategoryId]
  );

  return {
    onFilterItemClick,
    mobileFilterModalVisible,
    setMobileFilterModalVisible,
    selectedColorIds,
    setSelectedColorIds,
    selectedCategoryId,
    setSelectedCategoryId,
    onApply
  };
};

export default useMobileFilter;
